import {
  Box,
  IconButton, MenuItem,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { PopMenu } from '../../PopMenu';
import { useGetContactsQuery } from '../../../core/redux/contact';
import { useMakeCall } from '../../../core/redux/tbn';

export const ContactList = () => {
  const { data: contacts } = useGetContactsQuery();
  const [makeCall] = useMakeCall();

  const makePhoneCall = (phoneNumber: string): void => {
    makeCall(phoneNumber);
  };

  return (
    <PopMenu
      label="Kontaktliste"
      renderButton={(
        <IconButton
          edge="end"
          color="inherit"
          aria-label="profile"
        >
          <PhoneIcon sx={{ width: 36, height: 36 }} />
        </IconButton>
      )}
    >
      {contacts?.map((c) => (
        <MenuItem key={c.name} onClick={() => makePhoneCall(c.phone)}>
          {c.name ? `${c.company} (${c.name})` : c.company}
          <Box sx={{ flexGrow: 1, textAlign: 'right', ml: 1 }}>{c.phone}</Box>
        </MenuItem>
      ))}
    </PopMenu>
  );
};
